import { Agency } from 'src/types/Agency';

export interface IGetTenant {
  realm: string;
  welcome: string;
  theme: string;
  logo: string;
  agency: string;
  defaultPassword: string;
}

export function GetTenant(): IGetTenant {
  switch (import.meta.env.VITE_APP_TENANT) {
    case 'POLLYJOBS':
      return {
        realm: 'polly-jobs',
        welcome: 'Polly Jobs',
        theme: 'PollyTheme',
        logo: 'Polly',
        agency: 'Cliente',
        defaultPassword: 'pollyjobs'
      } as IGetTenant;
    case 'turtle':
      return {
        realm: 'turtle',
        welcome: 'Turtle Pictures',
        theme: 'TurtleTheme',
        logo: '/assets/logo.png',
        agency: 'Agência',
        defaultPassword: 'turtle'
      } as IGetTenant;
    case 'polly':
      return {
        realm: 'polly',
        welcome: 'Polly Pictures',
        theme: 'PollyTheme',
        logo: '/assets/polly_logo.png',
        agency: 'Cliente',
        defaultPassword: 'polly'
      } as IGetTenant;
    default:
      return {
        realm: 'turtle',
        welcome: 'Turtle Pictures',
        theme: 'TurtleTheme',
        logo: '/assets/logo.png',
        agency: 'Agência',
        defaultPassword: 'turtle'
      } as IGetTenant;
  }
}

export const GROUP_AGENCY = 'GROUP_AGENCY';
